export default "__VITE_ASSET__DugJLOkZ__"